!function ($, global) {
    'use strict';

    var $document = $(global.document);

    var RIGHT_MOUSE_BUTTON_WHICH = 3;

    var SELECTOR_MENU = '.nav-menu';
    var SELECTOR_ITEM = SELECTOR_MENU + ' .menu-item.menu-item-has-children';
    var SELECTOR_OPEN = '[data-toggle="nav-menu-open"]';
    var SELECTOR_CLOSE = '[data-toggle="nav-menu-close"]';
    var SELECTORS = [SELECTOR_OPEN, SELECTOR_CLOSE].join();

    var FIRST = ':eq(0)';

    var CLASS_MENU_OPEN = 'menu-open';
    var CLASS_MENU_CLOSING = 'menu-closing';
    var CLASS_ITEM_OPEN = 'menu-item-open';
    var CLASS_ITEM_CLOSING = 'menu-item-closing';

    var EVENT_KEY = '.omt.nav-menu';
    var CLICK_DATA_API = 'click' + EVENT_KEY;

    var MENU_CLOSING_TIME = 450;
    var ITEM_CLOSING_TIME = 250;

    $document
        .on(CLICK_DATA_API, SELECTORS, function (event) {
            if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) {
                return;
            }

            event.preventDefault();

            var $toggle = $(this);
            var $item = $toggle.parents(SELECTOR_ITEM + FIRST);
            var $menu = $item.parent();
            var $navMenu = $item.parents(SELECTOR_MENU + FIRST);
            var open = $toggle.data('toggle') === 'nav-menu-open';

            if(open) {
                $item.addClass(CLASS_ITEM_OPEN);
                $menu.addClass(CLASS_MENU_OPEN);

                $navMenu.css('min-height', $item.children('.sub-menu').outerHeight(true));
            } else {
                $item.removeClass(CLASS_ITEM_OPEN).addClass(CLASS_ITEM_CLOSING).delay(ITEM_CLOSING_TIME).delayed('removeClass', CLASS_ITEM_CLOSING);
                $menu.removeClass(CLASS_MENU_OPEN).addClass(CLASS_MENU_CLOSING).delay(MENU_CLOSING_TIME).delayed('removeClass', CLASS_MENU_CLOSING);

                $navMenu.css('min-height', $menu.parents('.sub-menu' + FIRST).outerHeight(true) || '');
            }

        });

}(jQuery, window);
